import {cssTheme} from '../theme'
import {css} from '../theme/css'

export const langSwitcher = css`
  // fixme(ui) && костыль чтобы перекрыть стили материала
  && {
    position: relative;
    text-transform: uppercase;

    cursor: pointer;
  }
`
export const checkIcon = css`
  color: ${cssTheme.default.day.text};
`
